export const NAME_FORMAT_TIMEZONE_OPTIONS = [
    { text: 'Pacific Time (PT)', value: 'Pacific Standard Time' },
    { text: 'Mountain Time (MT)', value: 'Mountain Standard Time' },
    { text: 'Central Time (CT)', value: 'Central Standard Time' },
    { text: 'Eastern Time (ET)', value: 'Eastern Standard Time' },
    { text: 'UTC', value: 'UTC' },
]

// Windows ids of Settings > Company > TimeZone (E_TypeOfTimeZone) -> IANA for Intl.
// Generated with .NET TimeZoneInfo.TryConvertWindowsIdToIanaId; the 3 ids Windows does
// not know (Jerusalem / Kamchatka / Mid-Atlantic) are mapped by hand, like the server.
const WIN_TO_IANA = {
    'Afghanistan Standard Time': 'Asia/Kabul',
    'Alaskan Standard Time': 'America/Anchorage',
    'Aleutian Standard Time': 'America/Adak',
    'Arab Standard Time': 'Asia/Riyadh',
    'Arabian Standard Time': 'Asia/Dubai',
    'Atlantic Standard Time': 'America/Halifax',
    'AUS Central Standard Time': 'Australia/Darwin',
    'AUS Eastern Standard Time': 'Australia/Sydney',
    'Azerbaijan Standard Time': 'Asia/Baku',
    'Azores Standard Time': 'Atlantic/Azores',
    'Bahia Standard Time': 'America/Bahia',
    'Bangladesh Standard Time': 'Asia/Dhaka',
    'Canada Central Standard Time': 'America/Regina',
    'Cape Verde Standard Time': 'Atlantic/Cape_Verde',
    'Caucasus Standard Time': 'Asia/Yerevan',
    'Cen. Australia Standard Time': 'Australia/Adelaide',
    'Central America Standard Time': 'America/Guatemala',
    'Central Asia Standard Time': 'Asia/Almaty',
    'Central Brazilian Standard Time': 'America/Cuiaba',
    'Central Europe Standard Time': 'Europe/Budapest',
    'Central European Standard Time': 'Europe/Warsaw',
    'Central Pacific Standard Time': 'Pacific/Guadalcanal',
    'Central Standard Time': 'America/Chicago',
    'Central Standard Time (Mexico)': 'America/Mexico_City',
    'China Standard Time': 'Asia/Shanghai',
    'Cuba Standard Time': 'America/Havana',
    'Dateline Standard Time': 'Etc/GMT+12',
    'E. Africa Standard Time': 'Africa/Nairobi',
    'E. Australia Standard Time': 'Australia/Brisbane',
    'E. South America Standard Time': 'America/Sao_Paulo',
    'Easter Island Standard Time': 'Pacific/Easter',
    'Eastern Standard Time': 'America/New_York',
    'Eastern Standard Time (Mexico)': 'America/Cancun',
    'Egypt Standard Time': 'Africa/Cairo',
    'Ekaterinburg Standard Time': 'Asia/Yekaterinburg',
    'Fiji Standard Time': 'Pacific/Fiji',
    'GMT Standard Time': 'Europe/London',
    'Greenland Standard Time': 'America/Godthab',
    'Greenwich Standard Time': 'Atlantic/Reykjavik',
    'GTB Standard Time': 'Europe/Bucharest',
    'Haiti Standard Time': 'America/Port-au-Prince',
    'Hawaiian Standard Time': 'Pacific/Honolulu',
    'India Standard Time': 'Asia/Kolkata',
    'Iran Standard Time': 'Asia/Tehran',
    'Israel Standard Time': 'Asia/Jerusalem',
    'Jerusalem Standard Time': 'Asia/Jerusalem',
    'Jordan Standard Time': 'Asia/Amman',
    'Kamchatka Standard Time': 'Asia/Kamchatka',
    'Korea Standard Time': 'Asia/Seoul',
    'Line Islands Standard Time': 'Pacific/Kiritimati',
    'Magadan Standard Time': 'Asia/Magadan',
    'Magallanes Standard Time': 'America/Punta_Arenas',
    'Marquesas Standard Time': 'Pacific/Marquesas',
    'Mid-Atlantic Standard Time': 'Etc/GMT+2',
    'Middle East Standard Time': 'Asia/Beirut',
    'Montevideo Standard Time': 'America/Montevideo',
    'Morocco Standard Time': 'Africa/Casablanca',
    'Mountain Standard Time': 'America/Denver',
    'Mountain Standard Time (Mexico)': 'America/Chihuahua',
    'Myanmar Standard Time': 'Asia/Yangon',
    'N. Central Asia Standard Time': 'Asia/Novosibirsk',
    'Nepal Standard Time': 'Asia/Kathmandu',
    'New Zealand Standard Time': 'Pacific/Auckland',
    'Newfoundland Standard Time': 'America/St_Johns',
    'North Asia East Standard Time': 'Asia/Irkutsk',
    'North Asia Standard Time': 'Asia/Krasnoyarsk',
    'Pacific SA Standard Time': 'America/Santiago',
    'Pacific Standard Time': 'America/Los_Angeles',
    'Pacific Standard Time (Mexico)': 'America/Tijuana',
    'Pakistan Standard Time': 'Asia/Karachi',
    'Paraguay Standard Time': 'America/Asuncion',
    'Romance Standard Time': 'Europe/Paris',
    'Russian Standard Time': 'Europe/Moscow',
    'SA Eastern Standard Time': 'America/Cayenne',
    'SA Pacific Standard Time': 'America/Bogota',
    'SA Western Standard Time': 'America/La_Paz',
    'Saint Pierre Standard Time': 'America/Miquelon',
    'Samoa Standard Time': 'Pacific/Apia',
    'Sao Tome Standard Time': 'Africa/Sao_Tome',
    'SE Asia Standard Time': 'Asia/Bangkok',
    'Singapore Standard Time': 'Asia/Singapore',
    'South Africa Standard Time': 'Africa/Johannesburg',
    'Sri Lanka Standard Time': 'Asia/Colombo',
    'Taipei Standard Time': 'Asia/Taipei',
    'Tasmania Standard Time': 'Australia/Hobart',
    'Tocantins Standard Time': 'America/Araguaina',
    'Tokyo Standard Time': 'Asia/Tokyo',
    'Tonga Standard Time': 'Pacific/Tongatapu',
    'Turks And Caicos Standard Time': 'America/Grand_Turk',
    'Ulaanbaatar Standard Time': 'Asia/Ulaanbaatar',
    'US Eastern Standard Time': 'America/Indiana/Indianapolis',
    'US Mountain Standard Time': 'America/Phoenix',
    'Venezuela Standard Time': 'America/Caracas',
    'Vladivostok Standard Time': 'Asia/Vladivostok',
    'W. Australia Standard Time': 'Australia/Perth',
    'W. Central Africa Standard Time': 'Africa/Lagos',
    'W. Europe Standard Time': 'Europe/Berlin',
    'West Asia Standard Time': 'Asia/Tashkent',
    'West Pacific Standard Time': 'Pacific/Port_Moresby',
    'Yakutsk Standard Time': 'Asia/Yakutsk',
    UTC: 'UTC',
}

// Server (Windows) names whose text differs from the id - the server builds the
// abbreviation in an inspection name from these (InspectionNameBuilder.ShortTimeZoneName).
const WIN_DISPLAY_NAME = {
    'Cape Verde Standard Time': 'Cabo Verde Standard Time',
    'Israel Standard Time': 'Jerusalem Standard Time',
    'Ekaterinburg Standard Time': 'Russia TZ 4 Standard Time',
    'Kamchatka Standard Time': 'Russia TZ 11 Standard Time',
    'N. Central Asia Standard Time': 'Novosibirsk Standard Time',
    'North Asia East Standard Time': 'Russia TZ 7 Standard Time',
    'North Asia Standard Time': 'Russia TZ 6 Standard Time',
    'Russian Standard Time': 'Russia TZ 2 Standard Time',
    'Singapore Standard Time': 'Malay Peninsula Standard Time',
    'Vladivostok Standard Time': 'Russia TZ 9 Standard Time',
    'Yakutsk Standard Time': 'Russia TZ 8 Standard Time',
    'Mid-Atlantic Standard Time': 'UTC-02',
}

export function timezoneToIana(timezone) {
    return WIN_TO_IANA[timezone] || timezone
}

// eslint-disable-next-line no-control-regex
const FILENAME_BAD_CHARS_RE = /[<>:"/\\|?*\x00-\x1F]/

export const DEFAULT_INSPECTION_NAME_CONFIG = {
    titleSource: 'template',
    otherText: '',
    includeDateTime: true,
    timezone: 'Pacific Standard Time',
    includeUsername: false,
}

export const DEFAULT_PDF_FILENAME_CONFIG = {
    titleSource: 'template',
    otherText: '',
    includeDateTime: true,
    timezone: 'Eastern Standard Time',
    includeUsername: false,
}

export const SAMPLE_TEMPLATE_NAME = 'Customer Complaint Log'

export function parseNameFormatConfig(raw) {
    if (!raw) return null
    try {
        const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
        return {
            titleSource: parsed.titleSource || 'template',
            otherText: parsed.otherText || '',
            includeDateTime: Boolean(parsed.includeDateTime),
            timezone: parsed.timezone || 'Pacific Standard Time',
            includeUsername: Boolean(parsed.includeUsername),
        }
    } catch {
        return null
    }
}

export function findIllegalFilenameChar(value) {
    if (!value) return null
    const match = value.match(FILENAME_BAD_CHARS_RE)
    return match ? match[0] : null
}

export function validateOtherText(value, isOtherSelected) {
    if (!isOtherSelected) {
        return { valid: true, message: '' }
    }
    if (!value || value.trim().length === 0) {
        return {
            valid: false,
            message:
                'Enter the custom title text (or pick a different Title option).',
        }
    }
    const bad = findIllegalFilenameChar(value)
    if (bad) {
        return {
            valid: false,
            message: `Character not allowed in a filename: "${bad}". Remove it.`,
        }
    }
    if (
        value !== value.trim() ||
        value.startsWith('.') ||
        value.endsWith('.')
    ) {
        return {
            valid: false,
            message: 'Cannot start or end with a space or dot.',
        }
    }
    return { valid: true, message: '' }
}

// Unknown zone ids make Intl throw - fall back to UTC.
function zoneParts(iana, date, options) {
    try {
        return new Intl.DateTimeFormat('en-CA', { timeZone: iana, ...options }).formatToParts(date)
    } catch {
        return new Intl.DateTimeFormat('en-CA', { timeZone: 'UTC', ...options }).formatToParts(date)
    }
}

export function formatNowInTimezone(timezone) {
    const iana = timezoneToIana(timezone)
    const now = new Date()
    const parts = zoneParts(iana, now, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZoneName: 'short',
    })
    const get = type => (parts.find(p => p.type === type) || {}).value || ''
    return `${get('year')}-${get('month')}-${get('day')} ${get('hour')}:${get('minute')} ${get('timeZoneName')}`
}

// Minutes the zone is ahead of UTC at `date`.
function zoneOffsetMinutes(iana, date) {
    const parts = zoneParts(iana, date, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
    })
    const n = type => Number((parts.find(p => p.type === type) || {}).value || 0)
    const asUtc = Date.UTC(n('year'), n('month') - 1, n('day'), n('hour'), n('minute'))
    return Math.round((asUtc - Math.floor(date.getTime() / 60000) * 60000) / 60000)
}

// Same abbreviation rule as the server: initials of the Windows standard / daylight
// name ("India Standard Time" -> IST, "Pacific Daylight Time" -> PDT); one word or
// "UTC..." stays as it is.
export function windowsZoneAbbreviation(timezone, date = new Date()) {
    const base = WIN_DISPLAY_NAME[timezone] || timezone || 'UTC'
    const iana = timezoneToIana(timezone)
    const year = date.getUTCFullYear()
    const jan = zoneOffsetMinutes(iana, new Date(Date.UTC(year, 0, 1)))
    const jul = zoneOffsetMinutes(iana, new Date(Date.UTC(year, 6, 1)))
    const isDst = jan !== jul && zoneOffsetMinutes(iana, date) === Math.max(jan, jul)
    const name = isDst ? base.replace('Standard', 'Daylight') : base
    if (!/[\s/-]/.test(name.trim()) || name.startsWith('UTC')) return name.trim()
    return name
        .split(/[\s/-]+/)
        .filter(w => w && /[A-Za-z]/.test(w[0]))
        .map(w => w[0].toUpperCase())
        .join('')
}

// What the server writes for the date part of an inspection name:
// "yyyy-MM-dd h_mm AM IST" (":" becomes "_" - names are made filename-safe).
export function formatInspectionNameDateTime(timezone, date = new Date()) {
    const iana = timezoneToIana(timezone)
    const parts = zoneParts(iana, date, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
    })
    const get = type => (parts.find(p => p.type === type) || {}).value || ''
    const dayPeriod = get('dayPeriod').replace(/\./g, '').toUpperCase()
    return `${get('year')}-${get('month')}-${get('day')} ${get('hour')}_${get('minute')} ${dayPeriod} ${windowsZoneAbbreviation(timezone, date)}`
}

export function shortFullName(name) {
    if (!name) return ''
    return name.replace(/\s+/g, '').slice(0, 10)
}

export function buildFormattedName(cfg, sample) {
    const parts = []

    if (cfg.titleSource === 'template') {
        parts.push(sample.templateName)
    } else if (cfg.titleSource === 'company') {
        parts.push(sample.companyName)
    } else if (cfg.titleSource === 'other' && cfg.otherText) {
        parts.push(cfg.otherText)
    }

    if (cfg.includeDateTime) {
        parts.push(formatInspectionNameDateTime(cfg.timezone || 'UTC'))
    }

    if (cfg.includeUsername) {
        const fn = shortFullName(sample.fullName)
        parts.push(fn || String(sample.userId))
    }

    return parts.join(' - ')
}

// The server uses the company time zone (Settings > Company) for inspection names
// whenever it is set; the format's own time zone is only the fallback.
export function withCompanyTimezone(cfg, companyTimeZone) {
    return companyTimeZone ? { ...cfg, timezone: companyTimeZone } : cfg
}

export function buildPdfFilenamePreview(cfg, sample) {
    const parts = []

    if (cfg.titleSource === 'template') {
        parts.push(sample.templateName)
    } else if (cfg.titleSource === 'company') {
        parts.push(sample.companyName)
    } else if (cfg.titleSource === 'other' && cfg.otherText) {
        parts.push(cfg.otherText)
    }

    if (cfg.includeDateTime) {
        // Same builder on the server as the inspection name ("h_mm AM <initials>").
        parts.push(formatInspectionNameDateTime(cfg.timezone || 'UTC'))
    }

    if (cfg.includeUsername) {
        const fn = shortFullName(sample.fullName)
        parts.push(fn || String(sample.userId))
    }

    let body = parts.join(' - ')
    if (!body) {
        body = `PdfInspection_${sample.userId}_${formatNowInTimezone(cfg.timezone || 'UTC').replace(/\W+/g, '')}`
    }

    const suffix = `_a${sample.auditId}`
    if (!body.includes(suffix)) {
        body += suffix
    }
    return `${body}.pdf`
}

export function toApiPayload(cfg) {
    return {
        titleSource: cfg.titleSource,
        otherText: cfg.titleSource === 'other' ? cfg.otherText : null,
        includeDateTime: cfg.includeDateTime,
        timezone: cfg.includeDateTime ? cfg.timezone : null,
        includeUsername: cfg.includeUsername,
    }
}

export function hasAtLeastOnePart(cfg) {
    if (cfg.titleSource && cfg.titleSource !== 'none') return true
    if (cfg.includeDateTime) return true
    if (cfg.includeUsername) return true
    return false
}

export function getPdfEffectiveSourceLabel(effectiveSource) {
    if (effectiveSource === 'PdfFilenameConfig') return 'PDF Config'
    if (effectiveSource === 'InspectionNameConfig (fallback)') {
        return 'Inherits audit name'
    }
    if (effectiveSource === 'Legacy default (PdfInspection_userId_datetime)') {
        return 'Legacy default'
    }
    return null
}
